export const jumpToTarget = target => {
  const $target = $(target);
  const headerHeight = $('#siteHeader').outerHeight();
  const scrollDistance = $target.offset().top - headerHeight;
  // console.log('scrollDistance', scrollDistance);
  $('html, body').stop().animate(
    { scrollTop: scrollDistance },
    {
      duration: 900,
      easing: 'swing',
      step: (now, fx) => {
        // Where is the target now located on the page?
        // i.e. its location will change as images etc. are lazy loaded
        const newOffset = $target.offset().top - headerHeight;
        if (fx.end !== newOffset) {
          fx.end = newOffset;
        }
      }
    }
  );
}



// WEBPACK FOOTER //
// ./src/bb/js/helpers/jumpToTarget.js